module.exports = __webpack_public_path__ + "img/measure.9a81ed9c.svg";